export enum SignalAppearanceTypes {
  Anonymous = 'anonymous',
  Profile = 'profile',
  Invisible = 'invisible',
}
